<template>
    <tab-content title="Instellingen">
        <g-form
            :action="`/api/admin/company/${this.$route.params.company_id}`"
            :prepopulate="true"
            @prepopulated="prepopulated"
            :form="this.form"
            message="Instellingen opgeslagen"
            method="patch"
            ref="mainForm"
            @loading-state="(state) => isLoading = state"
        >
            <div class="columns column-form is-desktop">
                <div class="column is-3-desktop is-2-widescreen">
                    <div class="tab-subheader">Algemeen</div>
                </div>
                <div class="column is-4-widescreen">
                        <div class="field-header">Primaire taal</div>
                        <p><small>De primaire taal is de standaard taal die gebruikt wordt voor het bedrijf.</small></p>
                        <g-select
                            name="locale"
                            :options="locales"
                        />

                        <div class="field-header">Lidmaatschapsgroep</div>
                        <g-select
                            name="membership_package_id"
                            :options="membershipPackages"
                            valuekey="id"
                        />

                        <div class="field-header">Affiliate</div>
                        <g-select
                            name="referral"
                            :options="affiliateOptions"
                            valuekey="id"
                        />

                        <div class="field-header">Rechten</div>
                        <g-switch
                            name="is_collaborative"
                            label="Samenwerkingsaccount"
                            subtitle="Dit account heeft beperkte toegangsrechten tot instellingen en het plaatsen van bestellingen"
                        />

                        <div class="field-header">Verificatie</div>
                        <g-switch
                            name="is_verified"
                            label="Geverifieerd account"
                            subtitle="Na verificatie worden bestellingen van dit account meegenomen tijdens het verwerken van de bestellingen."
                        />

                        <br/>
                </div>
            </div>

            <div class="columns column-form is-desktop mt-5">
                <div class="column is-3-desktop is-2-widescreen">
                    <div class="tab-subheader">E-mail branding</div>
                </div>
                <div class="column is-4-widescreen">
                    <div class="field-header">Aantal toegestane templates</div>
                    <g-input type="number" name="mail_templates_amount" min="0" max="100"/>

                    <div class="mt-5"></div>

                    <g-switch label="Wisselen van template toestaan"
                              subtitle="Indien ingeschakeld kunnen bedrijven hun eigen e-mail branding templates activeren. De consument zal e-mails ontvangen in de actieve branding van het bedrijf."
                              name="mail_templates_switchable"/>
                </div>
            </div>

            <div class="columns column-form is-desktop mt-5">
                <div class="column is-3-desktop is-2-widescreen">
                    <div class="tab-subheader">Functionaliteit</div>
                </div>
                <div class="column is-4-widescreen">
                    <div class="field-header">Verrekenoverzicht</div>
                    <g-switch label="'Overzicht per medewerker' zichtbaar" name="enable_employee_settlement"/>

                    <div class="field-header">Digitale bonnen</div>
                    <g-switch label="Fysiek versturen toestaan" name="allow_digital_postage_shipments"/>

                    <div class="field-header">Rapportages</div>
                    <g-switch label="Rapportages toegankelijk" name="enable_reports"/>
                    <g-switch label="Dagafsluiting toegankelijk" name="enable_report_daily_closing"/>

                    <g-button class="mt-5" type="submit" :loading="isLoading">Opslaan</g-button>
                </div>
            </div>
        </g-form>
    </tab-content>
</template>

<script>
import {mapGetters} from "vuex";
import TabContent from "../../../components/TabView/TabContent.vue";

export default {
    name: "Overview",
    components: {TabContent},
    data() {
        return {
            isLoading: false,
            membershipPackages: [],
            affiliateOptions: [
                {
                    id: null,
                    name: 'Geen',
                }
            ],
            form: new Form({
                locale: null,
                is_collaborative: null,
                is_verified: null,
                membership_package_id: null,
                referral: null,
                enable_employee_settlement: 0,
                allow_digital_postage_shipments: 0,
                enable_reports: 0,
                enable_report_daily_closing: 0,
                mail_templates_amount: 0,
                mail_templates_switchable: 0,
            }),
        }
    },
    mounted() {
        axios.get(`/api/admin/membership/packages`).then(({data}) => {
            this.membershipPackages = data.data
        })

        axios.get(`/api/admin/affiliate`).then(({data}) => {
            data.data.forEach((affiliate) => {
                this.affiliateOptions.push({
                    id: affiliate.id,
                    name: affiliate.slug
                })
            })
        })
    },

    computed: {
        ...mapGetters({
            locales: 'application/availableLocalesTranslated',
        }),
    },

    methods: {
        prepopulated({data}) {
            // Cast boolean values to integers to prevent issues with saving
            this.form.enable_employee_settlement = +data.enable_employee_settlement
            this.form.allow_digital_postage_shipments = +data.allow_digital_postage_shipments
            this.form.is_verified = +data.is_verified
        }
    }
}
</script>

<style scoped lang="scss">

</style>
